module.exports = __webpack_public_path__ + "static/img/5-6.481a04db.png";